import {
    API_SUCCESS,
    API_FAIL,
    GET_CHARTS_DATA,
    GET_DONUT_CHART_SUCCESS,
    GET_TOTAL_E_DOCUMENT_SUCCESS,
    GET_TOTAL_NOTIFICATION_SUCCESS,
    GET_STACKED_DATA_SUCCESS
} from "./actionTypes";

const INIT_STATE = {
    chartsData: [],
    donutChart:{},
    totalDoc:{},
    totalNotify:{},
    stackedData:{}
};

const Dashboard = (state = INIT_STATE, action) => {
    switch (action.type) {
        case API_SUCCESS:
            switch (action.payload.actionType) {
                case GET_CHARTS_DATA:
                    return {
                        ...state,
                        chartsData: action.payload.data
                    };
                default:
                    return state;
            }
        case API_FAIL:
            switch (action.payload.actionType) {
                case GET_CHARTS_DATA:
                    return {
                        ...state,
                        chartsDataError: action.payload.error
                    };


                default:
                    return state;
            }
        case GET_DONUT_CHART_SUCCESS:
            return {
                ...state,
                donutChart:action.payload
            };
        case GET_TOTAL_E_DOCUMENT_SUCCESS:
            return {
                ...state,
                totalDoc:action.payload.total
            };
        case GET_TOTAL_NOTIFICATION_SUCCESS:
            return {
                ...state,
                totalNotify:action.payload
            };
        case GET_STACKED_DATA_SUCCESS:
            return {
                ...state,
                stackedData:action.payload
            };
        default:
            return state;
    }
}


export default Dashboard;